import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Jsonp } from '@angular/http';

@Component({
  selector: 'page-instagram',
  templateUrl: 'instagram.html'
})
export class InstagramPage {

  client: any;
  event: any;
  dataSocial: any;
  dataInstagram: any;

  constructor(public navCtrl: NavController, public params: NavParams, public jsonp: Jsonp) {
    this.client = this.params.get('client');
    this.event = this.params.get('event');
    this.dataSocial = this.params.get('social');

    this.jsonp.request(this.dataSocial.instagramCode, {method: 'Get'}).subscribe((result: any) => {
      this.dataInstagram = result._body.data;
    });
  }

}
// end file



// WEBPACK FOOTER //
// ./src/pages/event-social/instagram/instagram.ts